import * as firebase from 'firebase';

const config = {
  apiKey: "AIzaSyBXFecYETCjZgd-SwZWmuhnhmICTnYTFRU",
  authDomain: "fantasy-fitness-draft.firebaseapp.com",
  databaseURL: "https://fantasy-fitness-draft.firebaseio.com",
  storageBucket: "fantasy-fitness-draft.appspot.com",
  messagingSenderId: "37397575813"
};
firebase.initializeApp(config);

export const ref = firebase.database().ref()
export const firebaseAuth = firebase.auth
export var uid = null;
export function setAuthUser(userId) {
    uid = userId;
}



// WEBPACK FOOTER //
// ./src/utils/firebase.js